import type { QuizBlock } from '@/types/blocks'
import { Label, Textarea } from '@teach/ui'
import { QUIZ_LIMITS } from '@/features/editor/constants/fieldLimits'
import { useContentLang } from '@/features/editor/hooks/useContentLang'
import { useContentMessages } from '@/features/editor/hooks/useContentMessages'
import { getLocalizedField, setLocalizedField } from '@/features/editor/lib/localizedField'
import { charsOk } from '@/features/editor/lib/quizWordLimits'
import { CharCount } from './shared/QuizFieldCounters'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  block: QuizBlock
  onChange: (next: QuizBlock) => void
  /** Пример под тип квиза; по умолчанию — общий. */
  placeholder?: string
}

// Отклик на НЕверный ответ. Отклик на верный убран по бэк-логу заказчика (п.22):
// он всегда системный. Поля correctFeedback/correctFeedbackEn остаются в типе и в
// данных — существующие курсы не трогаем, просто больше не показываем.
export const QuizFeedbackFields = ({ block, onChange, placeholder }: Props) => {
  const m = useMessages(messages)
  // Подсказки полей — на языке правки: видно, что правится английская версия.
  const cm = useContentMessages(messages)
  const lang = useContentLang()
  const setFeedback = (value: string) => {
    const prev = getLocalizedField(block, 'incorrectFeedback', lang)
    if (!charsOk(value, QUIZ_LIMITS.FEEDBACK, prev)) return
    onChange({ ...block, ...setLocalizedField('incorrectFeedback', lang, value) })
  }

  return (
    <section className="space-y-3">
      <div className="space-y-2">
        <Label htmlFor="fb-incorrect" className="font-medium text-foreground">
          {m.incorrectFeedback}{' '}
          <span className="font-normal text-muted-foreground/70">{m.optional}</span>
        </Label>
        <Textarea
          id="fb-incorrect"
          aria-label={m.incorrectFeedback}
          value={getLocalizedField(block, 'incorrectFeedback', lang) ?? ''}
          onChange={(e) => setFeedback(e.target.value)}
          maxLength={QUIZ_LIMITS.FEEDBACK}
          placeholder={placeholder ?? cm.feedbackPlaceholder}
          rows={2}
          className="resize-none rounded-xl"
        />
        <CharCount
          value={getLocalizedField(block, 'incorrectFeedback', lang)}
          max={QUIZ_LIMITS.FEEDBACK}
        />
      </div>
    </section>
  )
}
